export const timeToLabelMap = {
  FORENOON: 'labels.callback-time-of-day.forenoon',
  NOON: 'labels.callback-time-of-day.noon',
  AFTERNOON: 'labels.callback-time-of-day.afternoon',
  EVENING: 'labels.callback-time-of-day.evening'
}
